module.exports = __webpack_public_path__ + "img/1001980.dad4bbfb.jpg";